import { FunctionComponent } from 'react';

export const Beta: FunctionComponent = () => {
  return (
    <div className="px-3 py-0.5 text-tint font-medium tracking-wider bg-tint bg-opacity-20 rounded-lg border border-tint border-opacity-20">
      Beta
    </div>
  );
};
